__turbopack_context__.v({
  "container": "style-module-scss-module__-9l_aG__container",
  "enter": "style-module-scss-module__-9l_aG__enter",
  "exit": "style-module-scss-module__-9l_aG__exit",
  "fade-in": "style-module-scss-module__-9l_aG__fade-in",
  "fade-out": "style-module-scss-module__-9l_aG__fade-out",
  "fade-out-80": "style-module-scss-module__-9l_aG__fade-out-80",
  "slide-in-from-bottom": "style-module-scss-module__-9l_aG__slide-in-from-bottom",
  "slide-in-from-left": "style-module-scss-module__-9l_aG__slide-in-from-left",
  "slide-in-from-right": "style-module-scss-module__-9l_aG__slide-in-from-right",
  "slide-in-from-top": "style-module-scss-module__-9l_aG__slide-in-from-top",
  "slide-out-to-bottom": "style-module-scss-module__-9l_aG__slide-out-to-bottom",
  "slide-out-to-left": "style-module-scss-module__-9l_aG__slide-out-to-left",
  "slide-out-to-right": "style-module-scss-module__-9l_aG__slide-out-to-right",
  "slide-out-to-top": "style-module-scss-module__-9l_aG__slide-out-to-top",
  "zoom-in": "style-module-scss-module__-9l_aG__zoom-in",
  "zoom-out": "style-module-scss-module__-9l_aG__zoom-out",
});
